/* eslint-disable no-undef */
/* eslint-disable strict */
/* eslint-disable newline-per-chained-call */

////'use strict';

(async function AjaxCart() {
  /* eslint-disable */
  var renderCart = function (data) {
    (async () => {
      await getCrossSells(
        updateNavQty(
          appendMarkup(
            setCartTotal(
              initItemEvents(
                initAccountItemEvents(
                  initCartEvents(
                    await collateData(data)
                  )
                )
              )
            )
          )
        )
      );
    })();
    return promiseResolve();
  };
  /* eslint-enable */

  // var renderCart = Simba.Functional.compose(
  //   promiseResolve,
  //   getCrossSells,
  //   updateNavQty,
  //   appendMarkup,
  //   setCartTotal,
  //   initItemEvents,
  //   initAccountItemEvents,
  //   initCartEvents,
  //   collateData
  // );

  var publicAPI = {
    open: showCart,
    close: hideCart,
    isOpened: isCartOpen,
    cartAdd: cartAdd,
    fireGTMAddToCartEvents: fireGTMAddToCartEvents,
    cartCall: cartCall,
    cartChange: cartChange,
    cartUpdate: cartUpdate,
    refresh: cartRefresh,
    resetForm: resetForm,
    formSubmit: formSubmit,
    getCart: getCart,
    getUpsellData: getUpsellData,
    upsellFormSubmit: upsellFormSubmit
  };

  var format = Simba.Functional.partial(Simba.Money.format, Simba.Liquid.string('"£{{amount}}"'));
  var formatWithoutTrailingZeros = Simba.Functional.partial(
    Simba.Money.format,
    Simba.Liquid.string('"£{{amount_no_decimals}}"')
  );

  /**/
  // 24 month interest free cart message
  var interestFreeMessageThreshold = parseInt('25000', 10);
  var interestFreeTargetThreshold = parseInt('200000', 10);
  var interestFreeUnlockTemplate = '<strong>|AMOUNT| more unlocks 2 year 0% APR.</strong><br>1 year 0% APR &amp; 48 months 13.9% APR available currently.';
  /**/

  Simba.AjaxCart = publicAPI;

  // ******************************

  window.addEventListener('load', function () {
    /** ----------------------------
     * The code below is used for the mattress recycling service.
     * The cart is retrieved, we loop through and check if the
     * mattress recycling service (product) exists in the cart,
     * if it is present, it is removed because this means the customer
     * has moved away from the checkout page and has navigated back to* the site. SIM-3145
     */
    Simba.AjaxCart.getCart().then((cartContent) => {
      var items = {};
      var quantity = 0;
      cartContent.items.forEach((cartItem) => {
        // Check for existing mattress recycling service(s)
        if (cartItem.id === 43796115718318) {
          cartItem.quantity = quantity;
          items = { id: `${cartItem.id}`, quantity: quantity };
          cartCall(window.Simba.Lang.url + `/cart/change.js`, 'POST', items).then(() => {
            cartRefresh(false);
          });
        }
      });
    });

    cartRefresh(false);
  });

  async function collateData(cartObj) {
    var $cartMarkup = await createMarkup(cartObj);
    var ecoTaxTotal = await calculateEcoTaxTotal(cartObj);
    var cartLevelDiscountApplications = createCartLevelDiscountApplications(cartObj);

    cartObj.total_discount += await getExtraDiscountFromComparePrices(cartObj);
    const cartWithoutDelivery = cartObj.items.filter(
      (item) => item.handle !== 'delivery-charge' && item.handle !== 'mattress-setup-packaging-removal'
    );

    return {
      cart: cartObj,
      hasDiscount: cartObj.total_discount !== 0,
      isCartEmpty: cartWithoutDelivery.length === 0,
      ecoTaxTotal: ecoTaxTotal,
      cartLevelDiscountApplications: cartLevelDiscountApplications,
      $markup: $cartMarkup,
      $items: cartItems($cartMarkup),
      $accountUpsellItems: accountUpsells(),
      $navQty: $('[data-cart]'),
      $openTrigger: $('[data-cart-open]'),
      $closeTrigger: $('[data-cart-close]'),
      $formSubmitTrigger: $('[data-product-form]'),
      $btnSubmitTrigger: $('[data-atc]'),
      $cartContainer: $('[data-cart-container]'),
      $cartDiscount: $('[data-cart-discount]'),
      $cartDiscountValue: $('[data-cart-discount-value]'),
      $cartLevelDiscountsContainer: $('[data-cart-level-discounts-container]'),
      $cartEcoTaxTotal: $('[data-cart-eco-tax-total]'),
      $cartTotalValue: $('[data-cart-subtotal-value]'),
      /**/
      $interestFreeMessage: $('[data-cart-interest-free-message]'),
      /**/
      $cartState: $('[data-cart-empty]'),
      $quantitySelect: $('[data-quantity-select]'),
      $btnQuantityChange: $('[data-quantity-change]')
    };
  }

  function initCartEvents(data) {
    // Open & close cart
    data.$openTrigger.off('click').on('click', showCart);
    data.$closeTrigger.off('click').on('click', hideCart);

    // Close cart on escape key
    $(document).off('keydown').on('keydown', escapeKeyClose);

    // Add to cart, product form submit
    data.$formSubmitTrigger.off('submit').on('submit', formSubmit);
    // Add to cart, desktop bar button
    data.$btnSubmitTrigger.off('click').on('click', formSubmit);

    Simba.gtmAddEventListener('CartInitCheckout');
    Simba.Event.emit('ajaxCartInitialised');

    return data;
  }

  function initItemEvents(data) {
    data.$items.each(function (idx, item) {
      item.$select.on('change', async function selectChange() {
        await setItemPrice(data);
      });

      item.$qtyBtn.on('click', async function qtyClick() {
        this.setAttribute('disabled', true);

        // 0 is a removal, so lock the controls until complete
        if (Number(this.getAttribute('data-cart-qty-modifier')) === 0) {
          item.$qtyBtn.attr('disabled', true);
          item.$qtyInput.attr('disabled', true);
        }

        await setItemQty(item, this);
      });

      item.$qtyInput.on('change', async function qtyChange() {
        // Return if the qty input is a cross-sale item
        if (!this.hasAttribute('data-key')) return;
        cartChange({
          quantity: this.value,
          id: this.getAttribute('data-key')
        });
      });

      item.$atc.on('click', function atcClick() {
        itemAtc(item);
      });
    });

    return data;
  }

  function resetForm(form) {
    $(form).off('submit').on('submit', formSubmit);
  }

  function initAccountItemEvents(data) {
    data.$accountUpsellItems.each(function (idx, item) {
      item.$select.on('change', async function selectChange() {
        await setItemPrice(data);
      });

      item.$qtyBtn.on('click', function qtyClick() {
        setItemQty(item, this);
      });

      item.$qtyInput.on('change', function qtyChange() {
        // Return if the qty input is a cross-sale item
        if (!this.hasAttribute('data-key')) return;
        cartChange({
          quantity: this.value,
          id: this.getAttribute('data-key')
        });
      });

      item.$atc.on('click', function atcClick() {
        itemAtc(item, true);
      });
    });

    return data;
  }

  function setCartTotal(data) {
    var cart = data.cart;

    data.$cartTotalValue.html(formatWithoutTrailingZeros(cart.total_price));
    data.$cartDiscountValue.html(formatWithoutTrailingZeros(cart.total_discount));
    data.$cartState.attr('data-cart-empty', data.isCartEmpty);
    data.hasDiscount ? data.$cartDiscount.removeAttr('hidden') : data.$cartDiscount.attr('hidden', true);
    data.$cartEcoTaxTotal.html(format(data.ecoTaxTotal));
    data.$cartLevelDiscountsContainer.html(data.cartLevelDiscountApplications);
    /**/
    setInterestFreeMessage(data);
    /**/

    return data;
  }

  /**/
  function setInterestFreeMessage(data) {
    var $el = data.$interestFreeMessage;
    if (!$el || $el.length === 0) return;

    var total = data.cart.total_price;

    if (total < interestFreeMessageThreshold || total >= interestFreeTargetThreshold) {
      $el.attr('hidden', true).html('');
    } else {
      var remaining = interestFreeTargetThreshold - total;
      $el.html(interestFreeUnlockTemplate.replace('|AMOUNT|', format(remaining))).removeAttr('hidden');
    }
  }
  /**/

  function appendMarkup(data) {
    data.$cartContainer.html(data.$markup);
    return data;
  }

  function updateNavQty(data) {
    const cartWithoutDelivery = data.cart.items.filter(
      (item) => item.handle !== 'delivery-charge' && item.handle !== 'mattress-setup-packaging-removal'
    );
    let cartItemQuantity = 0;
    cartWithoutDelivery.forEach((cartItem) => {
      cartItemQuantity += cartItem.quantity;
    });
    data.$navQty.attr('data-cart', cartItemQuantity);
    const cartLink = data.$navQty.parent();

    if (cartLink) {
      if (cartLink.attr('href') && cartLink.attr('href') !== '' && cartWithoutDelivery.length === 0) {
        cartLink.removeAttr('href');
      } else if ((!cartLink.attr('href') || cartLink.attr('href') === '') && cartWithoutDelivery.length > 0) {
        cartLink.attr('href', '/cart');
      }
    }
    return data;
  }

  function getAtcData() {
    var obj;
    var ids;
    var $formSubmitTrigger = $('[data-product-form]');
    var selectedId = $formSubmitTrigger.find('[data-variant-select]').val();
    var upsellSelectedEl = $formSubmitTrigger.find('#upsell-selected');
    var quantity =
      $formSubmitTrigger.find('[data-quantity-select]').length > 0 ? parseInt($formSubmitTrigger.find('[data-quantity-select]').val(), 10) : 1;
    const maxQuantity = parseInt($formSubmitTrigger.find('[data-quantity-select]').attr('max'), 10) || null;
    var $option = $formSubmitTrigger.find(':selected');
    var multiIds = $option.attr('data-multi');
    const variantSelectEl = document.querySelector('[data-variant-select]');
    const variantSelectIds = variantSelectEl ? variantSelectEl.dataset.multi : null;
    var lineProperties = getAtcLineProperties();
    var bedBaseId = $('[data-bed-base-id]').attr('data-bed-base-id');
    var freeQuantity = $option.data('free-item') ? parseInt($option.data('free-item'), 10) : 0;

    if (upsellSelectedEl.length > 0 && upsellSelectedEl[0].checked) {
      selectedId = $formSubmitTrigger.find('#upsell-variant-id').val();
    }

    ids = multiIds ? multiIds.split(',').concat(selectedId) : [selectedId];
    ids = bedBaseId ? ids.concat(bedBaseId.split(',')) : ids;
    ids = variantSelectIds ? ids.concat(variantSelectIds.split(',')) : ids;

    obj = ids.reduce(function (acc, cur) {
      acc[cur] = (acc[cur] || 0) + quantity + freeQuantity;
      return acc;
    }, {});

    return Object.keys(obj).map(function (key) {
      return {
        id: key,
        quantity: obj[key],
        maxQuantity,
        properties: lineProperties
      };
    });
  }

  /* CRO SIM-3120 */
  function getUpsellData() {
    var obj;
    var $upsellFormFields = $('[data-upsell-form]');
    var selectedId = $upsellFormFields.find('[data-upsell-select]').val();
    var quantity =
      $upsellFormFields.find('[data-quantity-select]').length > 0 ? parseInt($upsellFormFields.find('[data-quantity-select]').val(), 10) : 1;
    var $option = $upsellFormFields.find(':selected');
    var multiIds = $option.attr('data-multi');
    var lineProperties = getAtcLineProperties();
    var freeQuantity = $option.data('free-item') ? parseInt($option.data('free-item'), 10) : 0;

    var ids = multiIds ? multiIds.split(',').concat(selectedId) : [selectedId];

    obj = ids.reduce(function (acc, cur) {
      acc[cur] = (acc[cur] || 0) + quantity + freeQuantity;
      return acc;
    }, {});

    return Object.keys(obj).map(function (key) {
      return { id: key, quantity: obj[key], properties: lineProperties };
    });
  }

  async function upsellFormSubmit(data, showUpsell = true) {
    var cart;
    var $btnAddToCart = $('[data-upsell-accept]');
    const upsellData = getUpsellData();

    // eslint-disable-next-line newline-per-chained-call
    cart = cartAdd(upsellData, showUpsell).then(getCart).then(emitCartAdd).then(renderCart).then(showCart).then(fireGTMAddToCartEvents(upsellData));

    cart.always(function () {
      // Check for cart update and send tracking data
      if (data.updates) {
        cartCall(window.Simba.Lang.url + '/cart.js', 'GET', false)
          .then(function (cartData) {
            cartData.items.forEach(function (item) {
              if (typeof data.updates[item.key] === 'number' && data.updates[item.key] !== item.quantity) {
                const isRemoval = data.updates[item.key] < item.quantity ? 1 : 0;
                fireGTMCartUpdateCartEvent({
                  itemKey: item.key,

                  quantityOld: item.quantity,
                  quantityNew: data.updates[item.key],
                  quantityChanged: parseInt(item.quantity - data.updates[item.key], 10),
                  isRemoveButtonPressed: isRemoval
                });
              }
            });
          })
          .then(function () {
            // Perform cart update
            cartUpdate(data, false);
          });
      }

      // Set attrs
      $btnAddToCart.attr('data-upsell-accept', '');
      $btnAddToCart.attr('disabled', false);
    });

    return true;
  }

  function cartUpdate(data) {
    var dfd = jQuery.Deferred();

    cartCall(window.Simba.Lang.url + '/cart/update.js', 'POST', data)
      .then(emitCartAdd)
      .then(renderCart);

    return dfd.promise();
  }

  /* END CRO SIM-3120 */

  function getAtcLineProperties() {
    var linePropertiesInputs = $.makeArray($('[data-product-line-properties] input'));

    var props = linePropertiesInputs.reduce(function lineProperty(acc, input) {
      var name = input.name.replace('properties[', '').replace(']', '');
      acc[name] = input.value;
      return acc;
    }, {});

    return props;
  }

  function cartAdd(variants, showUpsell = true) {
    var dfd = jQuery.Deferred();
    cartCall(window.Simba.Lang.url + '/cart/add.js', 'POST', { items: variants })
      .then(function (response) {
        if (typeof Simba.UpsellDrawer !== 'undefined' && showUpsell) {
          Simba.UpsellDrawer.invokeUpsell(response.items, 'mattress');
        }

        if (typeof Simba.UpsellDrawer !== 'undefined' && showUpsell && Simba.Upsell.show_accessory_upsell_cro) {
          Simba.UpsellDrawer.invokeUpsell(response.items, 'accessory');
        }
        dfd.resolve();
      })
      .catch((err) => dfd.reject(err));
    return dfd.promise();
  }

  function emitCartAdd(cartData) {
    var dfd = jQuery.Deferred();

    Simba.Cart = $.extend(Simba.Cart, cartData);
    Simba.Event.emit('cart:change', { cart: Simba.Cart });
    fireGTMFullCartChangeEvent();
    dfd.resolve(cartData);

    return dfd.promise();
  }

  async function cartChange(data) {
    cartCall(window.Simba.Lang.url + '/cart/change.js', 'POST', data)
      .then(emitCartAdd)
      .then(renderCart)
      .catch((err) => {
        cartRefresh(false);
        throw err;
      });
  }

  function cartRefresh(show) {
    getCart()
      .then(emitCartAdd)
      .then(renderCart)
      .then(function () {
        if (show) {
          showCart();
        }
      });
    return false;
  }

  function showCart() {
    showCartUI().then(fireGTMAjaxCartViewedEvent);
    Simba.Event.emit('ajaxCartOpened');

    return false;
  }

  function showCartUI() {
    var dfd = jQuery.Deferred();

    $('html').addClass('cart-open');
    $('body').addClass('ajax-cart-show');

    dfd.resolve();
    return dfd.promise();
  }

  function hideCart() {
    $('html').removeClass('cart-open');
    $('body').removeClass('ajax-cart-show');
    return false;
  }

  function isCartOpen() {
    return $('body').hasClass('ajax-cart-show');
  }

  function escapeKeyClose(evt) {
    if (evt.keyCode === 27 && isCartOpen()) hideCart();
  }

  /**
   * Add To Cart Form Submission
   *
   * @param {Event} event The form submission event
   * @param {Object} items The items to add to the cart (from SIM-5448 CRO PDP form)
   */
  async function formSubmit(event = false, items = false, openCart = true) {
    const btnAddToCart = document.querySelectorAll('[data-atc-submit]');
    let atcData;

    if (event) {
      // Get atc data from event data
      atcData = getAtcData();
    } else if (items) {
      // Get atc data from object
      atcData = await getPayloadData(items);
    }

    if (event?.currentTarget?.hasAttribute('data-form-open-cart') && event?.currentTarget?.getAttribute('data-form-open-cart') === 'false') {
      openCart = false;
    }

    btnAddToCart.forEach((button) => {
      button.setAttribute('data-atc-submit', 'submitting');
      button.disabled = true;
    });

    await Simba.CWV.interactionResponse();

    cartAdd(atcData, false)
      .then(fireGTMAddToCartEvents(atcData))
      .then(getCart)
      .then(emitCartAdd)
      .then(renderCart)
      .then(() => {
        if (openCart) showCart();
      })
      .always(() => {
        btnAddToCart.forEach((button) => {
          button.setAttribute('data-atc-submit', '');
          button.disabled = false;
        });
      })
      .then(() => {
        Simba.Event.emit('product-form:add-to-cart', atcData);
      });
  }

  async function getPayloadData(items) {
    const payload = [];
    await Promise.all(
      Object.keys(items).map(async (variantId) => {
        // Map the variant data to the desired payload structure
        const variantPayload = {
          id: variantId,
          quantity: items[variantId].quantity,
          properties: items[variantId].properties || {}
        };
        payload.push(variantPayload);
      })
    );
    return payload;
  }

  function getCartConfig() {
    if (!document.querySelector('[data-cart-config]')) return false;
    return JSON.parse(document.querySelector('[data-cart-config]').innerHTML);
  }

  // prettier-ignore
  async function createMarkup(cart) {
    /* eslint-disable */
    var cartConfig = getCartConfig();

    // Remove Delivery Products From Cart Array
    const items = cart.items.filter((item) => item.handle !== 'delivery-charge' && item.handle !== 'mattress-setup-packaging-removal');

    // Generate HTML Render Template
    const itemTemplate = await items.reduce(async function (accPromise, cartItem) {
      var acc = await accPromise;
      const productData = await Simba.ProductAsync.load(cartItem.variant_id);
      // If compare_at prices are in use, use them instead of the normal original price
      var originalPrice = formatWithoutTrailingZeros(cartItem.original_line_price);
      var variant = await Simba.ProductAsync.load(cartItem.variant_id);

      if (variant?.compareAtPriceRaw > cartItem.original_price) {
        originalPrice = formatWithoutTrailingZeros(variant?.compareAtPriceRaw * cartItem.quantity);
      }
      var finalPrice = formatWithoutTrailingZeros(cartItem.final_line_price);

      // Check For Cart Product Flash
      var productFlash = '';
      if (typeof cartConfig.promotion_products[cartItem.handle] === 'object') {
        if (typeof cartConfig.promotion_products[cartItem.handle].cart_product_flash === 'string') {
          if (cartItem.total_discount === 0) {
            productFlash = '<div class="relative"><span class="bundle-saving self-center py-5 inline-block mt-5" style="margin-left: 0px;">' + cartConfig.promotion_products[cartItem.handle].cart_product_flash + '</span></div>';
          }
        }
      }

      var itemTitle = (cartItem.variant_title)
        ? '<span class="cart-item__variant-title pr-20 text-14 md:text-16 text-dark">' + cartItem.variant_title + '</span>'
        : '';

      if (cartItem.product_type.toLowerCase() === 'bed base') {
        itemTitle = '';

        for (let index = 0; index < cartItem.options_with_values.length; index++) {
          itemTitle += '<span class="cart-item__variant-title pr-20 text-14 md:text-16 text-dark">' + cartItem.options_with_values[index].name + ': ' + cartItem.options_with_values[index].value + '</span><br>';
        }
      }

      if (cartItem.product_type === 'Accident Cover') {
        const cartTypes = items.map((item) => item.product_type);
        let accidentCoverIncluded = '';

        if (cartTypes.includes('Mattress') && cartTypes.includes('Bed Base')) {
          accidentCoverIncluded = 'Mattress & Bed';
        } else if (cartTypes.includes('Mattress')) {
          accidentCoverIncluded = 'Mattress';
        } else if (cartTypes.includes('Bed Base')) {
          accidentCoverIncluded = 'Bed';
        }

        itemTitle = `
          <span class='cart-item__variant-title pr-20 text-14 md:text-16 text-dark'>What's covered:</span><br>
          <span class='cart-item__variant-title pr-20 text-14 md:text-16 text-dark'>${accidentCoverIncluded}</span>
        `;
      }

      var itemEadd = (variant.eaddFormatted)
        ? '<span class="cart-item__eadd text-blue-accent block text-12">' + 'Earliest delivery date ' + variant.eaddFormatted + '</span>'
        : '';

      var itemPriceClasses = (cartItem.original_line_price !== cartItem.final_line_price) ? 'items-end' : 'justify-end items-end h-full';
      var itemPrice = (cartItem.original_line_price !== cartItem.final_line_price) ? '<span class="cart-item__original-price line-through text-14 font-400 text-dark">' + originalPrice + '</span><span class="cart-item__price text-16 leading-tight font-600 text-dark">' + finalPrice + '</span>'
      : ((variant.compareAtPriceRaw * cartItem.quantity) > cartItem.final_line_price && Simba.ProductDiscount.compareAtPricingType === 'CA') ? '<span class="cart-item__original-price line-through">' + formatWithoutTrailingZeros(variant.compareAtPriceRaw * cartItem.quantity) + '</span><span class="cart-item__price text-blue-accent">' + finalPrice + '</span>'
        : '<span>' + finalPrice + '</span>';


      var itemImg = (cartItem.image === null)
        ? 'https://cdn.simbasleep.com/b0defcef-c838-42da-afdc-81fe91083a5b/cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
        : cartItem.image.replace(/(\.[^.]*)$/, '_200x$1');

      acc += `
        <div class="ajax-cart__item relative flex gap-x-18 shadow w-full p-10 radius-5 border-1 border-color-cart-item" data-cart-item data-test="cart-item">
          <a href="${cartItem.url}">
            <div class="ajax-cart__item-image w-65 xs:w-115 xs:h-85">
              <img class="block w-full h-full object-contain object-center" alt="${cartItem.product_title}" src="${itemImg}" />
            </div>
          </a>

          <div class="flex flex-col items-start w-full">

            <div class="mb-12">
              <span class="cart-item__title text-16 font-600 text-dark block pr-20 mb-4">${cartItem.product_title}</span> ${itemTitle} ${itemEadd} ${productFlash}
            </div>

            ${(cartItem => {
              if (cartItem.product_type === 'Accident Cover') {
                return `
                  <div class="flex justify-between items-end w-full">
                    <button type="button"
                            class="mt-auto text-blue-accent font-500 text-16"
                            onclick="window.dispatchEvent(new Event('cart:cover:show-info'))"
                    >Info</button>
                    <input type="hidden" class="input-number-reset border-0 text-center max-w-full h-full bg-transparent" data-cart-qty-input value="${cartItem.quantity}" min="0" data-key="${cartItem.key}"  />
                    <div class="relative text-right text-16 leading-tight font-600 text-dark flex flex-col items-end">${itemPrice}</div>
                  </div>
                `;
              } else if (cartItem.product_type === 'Charity Bundle') {
                return `
                  <div class="relative">
                    <div class="relative max-w-100 float-left">
                      <label>
                        <span class="visually-hidden">Quantity</span>
                        <input type="number" class="input-number-reset border-0 max-w-full h-full bg-transparent" data-cart-qty-input value="${cartItem.quantity}" min="0" data-key="${cartItem.key}"  />
                      </label>
                    </div>
                  </div>
                `;
              } else {
                // CARTLINE  QUANTITY INPUT
                return `
                  <div class="flex w-full">
                    <label for="quantity-${cartItem.key}">
                      <span class="visually-hidden">Quantity</span>
                    </label>
                    <div class="qty-selector rounded-form-style flex flex-row justify-start w-min" style="flex-grow: 1;">
                      <div class="flex shrink-0 min-w-fit items-center">
                        <button type="button" class="relative" data-cart-qty-modifier="-1" aria-label="Decrease Quantity">
                          <svg class="cart-item__minus block svg-icon text-dark" width="20" height="20"><use xlink:href="#icon-cart-minus"></use></svg>
                        </button>
                        <input
                          type="number"
                          id="quantity-${cartItem.key}"
                          name="line-quantity"
                          class="qty-selector__input-cart qty-selector__input text-dark"
                          data-cart-qty-input
                          value="${cartItem.quantity}"
                          ${productData?.inventory?.tracked ? `max="${productData.inventory.availableQuantity}"` : ''}
                          min="0"
                          data-key="${cartItem.key}"
                        />
                        <button
                          type="button"
                          class="relative"
                          data-cart-qty-modifier="1"
                          ${(productData?.inventory?.tracked && parseInt(cartItem.quantity, 10) === parseInt(productData.inventory.availableQuantity, 10)) ? `disabled` : ''}
                          aria-label="Increase Quantity">
                          <svg class="cart-item__plus block svg-icon text-dark" width="20" height="20"><use xlink:href="#icon-cart-plus"></use></svg>
                        </button>

                      </div>
                    </div>

                    <div class="relative text-right text-16 leading-tight font-600 text-dark flex flex-col ${itemPriceClasses}">${itemPrice}</div>
                  </div>
                `;
              }

            })(cartItem)}

          </div>

          <div class="flex flex-col absolute top-0 right-0 h-full md:max-h-125 py-10 pr-10 justify-between items-end ml-auto">
            <button type="button" class="relative" data-cart-qty-modifier="0" aria-label="Remove item">
              <svg class="block svg-icon text-dark" width="20" height="20">
                <use xlink:href="#icon-cart-close-thin"></use>
              </svg>
            </button>
          </div>

        </div>`;

      return acc;
    }, '');

    const checkoutButton = document.querySelector('[data-checkout-button');
    const checkoutLink = checkoutButton?.getAttribute('href');
    // Update the Checkout button href if not already set and the cart has items
    if (items.length > 0 && (!checkoutLink || checkoutLink === '')) {

      // Set Checkout URL & Suppress Shop Pay If Enabled
      let checkoutUrl = `https://${window.location.host}/${window.Simba.Lang.url}checkout`;
      if (checkoutButton.dataset.suppressShopPay) {
        checkoutUrl += '?skip_shop_pay=true&shop_pay_checkout_as_guest=true';
      }

      // Set Button URL
      checkoutButton.setAttribute('href', checkoutUrl);

    // Remve the checkout button href if the cart has no items
    } else if (items.length === 0 && checkoutLink) {
      checkoutButton.removeAttribute('href');
    }
    return $('<div class="flex flex-col gap-y-16">').html(itemTemplate);
    /* eslint-enable */
  }

  async function getCrossSells(data) {
    var $markup = await getCrossSaleMarkup();
    initCrossSellSlick(appendCrossSellMarkup(await setItemPrice(initItemEvents(collateCrossSellData($markup)))));

    function collateCrossSellData($markupInner) {
      var items = cartItems($markupInner);

      return {
        required: items.length > 0,
        $markup: $markupInner,
        $items: items,
        $container: $('[data-ajax-cart] [data-cross-sell-container]'),
        $sliderContainer: $markupInner.find('[data-cross-sell-slider]')
      };
    }

    function appendCrossSellMarkup(crossSellData) {
      if (crossSellData.required) {
        crossSellData.$container.html(crossSellData.$markup);
        $('[data-cross-sell-wrapper]').show();
      } else {
        $('[data-cross-sell-wrapper]').hide();
      }

      return crossSellData;
    }

    function initCrossSellSlick(crossSellData) {
      // Only Boot If We Have The Cart Container In The DOM
      if (document.querySelector('[data-cross-sell-slider]')) {
        // eslint-disable-next-line
        new tns({
          container: crossSellData.$sliderContainer[0],
          loop: true,
          nav: false,
          speed: 400,
          gutter: 20,
          prevButton: '[data-ajax-cart] [data-chevron-left]',
          nextButton: '[data-ajax-cart] [data-chevron-right]',
          mouseDrag: true
        });
      }
    }

    return data;
  }

  function cartItems($markup) {
    var $items = $markup.find('[data-cart-item]');

    return $items.map(function (idx, item) {
      var $item = $(item);

      return {
        $select: $item.find('[data-cart-slider-select]'),
        $originalPrice: $item.find('[data-original-price]'),
        $price: $item.find('[data-price]'),
        $priceWrap: $item.find('[data-has-discount]'),
        $qtyBtn: $item.find('[data-cart-qty-modifier]'),
        $qtyInput: $item.find('[data-cart-qty-input]'),
        $atc: $item.find('[data-cart-item-atc]')
      };
    });
  }

  function accountUpsells() {
    var $items = $('[data-upsell-item]');

    return $items.map(function (idx, item) {
      var $item = $(item);

      return {
        $select: $item.find('[data-cart-slider-select]'),
        $originalPrice: $item.find('[data-compare-price]'),
        $price: $item.find('[data-price]'),
        $priceWrap: $item.find('[data-has-discount]'),
        $qtyBtn: $item.find('[data-cart-qty-modifier]'),
        $qtyInput: $item.find('[data-cart-qty-input]'),
        $atc: $item.find('[data-cart-item-atc]')
      };
    });
  }

  function setItemQty(item, btn) {
    var $qtyInput = item.$qtyInput;
    const maxAllowed = $qtyInput.attr('max') ? Number($qtyInput.attr('max')) : null;
    var qtyModifier = Number(btn.getAttribute('data-cart-qty-modifier'));
    var qtyMin = Number($qtyInput.attr('min'));
    var qtyOld = Number($qtyInput.val());
    const newQuantity = qtyOld + qtyModifier;
    var qtyNew = qtyModifier === 0 ? 0 : newQuantity;
    var optionData = {};
    var qtyChanged = 0;

    // Check the requested quantity is not greater than the max allowed
    if (maxAllowed) {
      if (newQuantity === maxAllowed) {
        btn.disabled = true;
      } else {
        btn.disabled = false;
      }
      if (newQuantity > maxAllowed) {
        return;
      }
    }

    // If quantity has not changed, do nothing
    if (clamp(qtyNew, qtyMin, 100) === qtyOld) return;

    // Update page input and trigger change
    $qtyInput.val(clamp(qtyNew, qtyMin, 100)).trigger('change');

    // Return if the qty input is a cross-sale item
    if (!$qtyInput.data('key')) return;

    if (qtyOld > qtyNew) {
      qtyChanged = parseInt(qtyOld - qtyNew, 10);
    } else {
      qtyChanged = parseInt(qtyNew - qtyOld, 10);
    }

    optionData = {
      itemKey: $qtyInput.data('key'),
      quantityOld: qtyOld,
      quantityNew: qtyNew,
      quantityChanged: qtyChanged,
      isRemoveButtonPressed: qtyModifier === 0
    };

    fireGTMCartUpdateCartEvent(optionData);
  }

  async function setItemPrice(data) {
    await data.$items.each(async function (idx, item) {
      var id = item.$select.val();
      // var variant = Simba.Product[id];
      var variant = await Simba.ProductAsync.load(id);
      var price = 0;
      var hasDiscount = false;
      var originalPrice = 0;

      if (variant) {
        originalPrice = variant.originalPriceFormattedWithoutTrailingZeros;
      }

      if (variant) {
        price = variant.priceFormatted;
        hasDiscount = variant.hasDiscount;
      }

      item.$price.text(price);
      item.$originalPrice.text(originalPrice);
      item.$priceWrap.attr('data-has-discount', hasDiscount);
      hasDiscount ? item.$price.removeAttr('hidden') : item.$price.attr('hidden', true);
    });

    return data;
  }

  function itemAtc(item, show) {
    // Added Properties
    var props = {};
    var linePropertiesInputs = $.makeArray(item.$atc.parent().find('[data-product-line-properties] input'));

    // Disable the button to prevent multiple clicks
    item.$atc.attr('disabled', true);

    if (linePropertiesInputs) {
      props = linePropertiesInputs.reduce(function lineProperty(acc, input) {
        var name = input.name.replace('properties[', '').replace(']', '');
        acc[name] = input.value;
        return acc;
      }, {});
    }

    if (!show) {
      show = false;
    }

    cartAdd([
      {
        id: item.$select.val(),
        quantity: item.$qtyInput.val(),
        maxQuantity: parseInt(item.$select.attr('max'), 10) || null,
        properties: props
      }
    ])
      .then(
        fireGTMAddToCartEvents([
          {
            id: item.$select.val(),
            quantity: item.$qtyInput.val(),
            properties: props
          }
        ])
      )
      .then(getCart)
      .then(emitCartAdd)
      .then(renderCart)
      .then(show ? showCart : null);
  }

  // Cart changes we've asked Shopify for and are still waiting to hear back on
  const inFlightChanges = new Map();

  // Call Shopify, but if already asking for exact same cart change, wait for answer instead of asking again
  function cartCall(endpoint, method, args) {
    if (method.toUpperCase() !== 'POST' || !endpoint.endsWith('/cart/change.js')) {
      return cartRequest(endpoint, method, args);
    }

    const key = endpoint + JSON.stringify(args);
    if (!inFlightChanges.has(key)) {
      inFlightChanges.set(
        key,
        cartRequest(endpoint, method, args).finally(() => inFlightChanges.delete(key))
      );
    }
    return inFlightChanges.get(key);
  }

  // Send the request to Shopify (if rate limited, try one more time)
  async function cartRequest(endpoint, method, args, isRetry = false) {
    const fetchOptions = {
      method: method,
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    };

    if (args && method.toUpperCase() !== 'GET') {
      fetchOptions.headers['Content-Type'] = 'application/json';
      fetchOptions.body = JSON.stringify(args);
    }

    const request = await fetch(endpoint, fetchOptions);

    // If rate limited, wait (Retry-After or 1s) and retry once
    if (request.status === 429 && !isRetry) {
      const retryAfter = Number(request.headers.get('Retry-After'));
      await new Promise((resolve) => setTimeout(resolve, retryAfter > 0 ? Math.min(retryAfter, 5) * 1000 : 1000));
      return cartRequest(endpoint, method, args, true);
    }

    if (!request.ok) {
      switch (request.status) {
        case 400:
          throw new Error('Bad Request: Invalid request parameters');
        case 401:
          throw new Error('Unauthorized: Authentication required');
        case 403:
          throw new Error('Forbidden: Access denied');
        case 404:
          throw new Error('Not Found: Resource does not exist');
        case 429:
          throw new Error('Too Many Requests: Rate limit exceeded');
        case 500:
          throw new Error('Server Error: Internal server error');
        case 502:
          throw new Error('Bad Gateway: Invalid response from server');
        case 503:
          throw new Error('Service Unavailable: Server is temporarily unavailable');
        default:
          throw new Error(`${request.status} ${request.statusText || 'Network Error'}`);
      }
    }
    return request.json();
  }

  // URL Override For Paired Products And Adding Tags
  async function setURLsAndTags(cart) {
    await cart.items.forEach(async function (item) {
      var variant = await Simba.ProductAsync.load(item.id);
      if (variant !== undefined && typeof variant === 'object') {
        // Update Urls for paired products
        if (variant.paired_product.handle && !variant.paired_product.is_parent) {
          item.url = item.url.replace(item.handle, variant.paired_product.handle);
          item.url = item.url.replace(item.id, variant.paired_product.id);
        }

        // Add Tags
        item.product_tags = variant.tags;
      }
    });

    return cart;
  }

  function getCart() {
    var dfd = jQuery.Deferred();
    cartCall(window.Simba.Lang.url + '/cart.js', 'GET', false).then(function (cart) {
      setURLsAndTags(cart).then(function (cartInner) {
        dfd.resolve(cartInner);
      });
    });

    return dfd.promise();
  }

  function getCrossSaleMarkup() {
    var dfd = jQuery.Deferred();
    var url = window.Simba.Lang.url + '/pages/cross-sells';

    $.get(url).then(function (data) {
      dfd.resolve($(data));
    });

    return dfd.promise();
  }

  function promiseResolve() {
    var dfd = jQuery.Deferred();
    dfd.resolve('cart rendered');

    return dfd.promise();
  }

  function clamp(val, min, max) {
    return val > max ? max : val < min ? min : val;
  }

  function fireGTMAddToCartEvents(variants) {
    var dfd = jQuery.Deferred();

    var variant = variants.shift();

    fireGTMAddToCartEvent(variant).then(function () {
      variants.length ? fireGTMAddToCartEvents(variants) : dfd.resolve();
    });

    dfd.resolve();
    return dfd.promise();
  }

  function fireGTMAddToCartEvent(variant) {
    var promise = new Promise((resolve) => {
      window.Simba.gtmConstructEventData('ProductAddToCart', variant).then((eventData) => {
        window.Simba.gtmPushEvent(eventData);
        resolve();
      });
    });

    return promise;
  }

  function fireGTMAjaxCartViewedEvent() {
    var promise = new Promise((resolve) => {
      Simba.gtmConstructEventData('AjaxCartViewed').then((eventData) => {
        Simba.gtmPushEvent(eventData);
        resolve();
      });
      const eventData = window.Simba.gtmConstructEventData('virtualPageView', {
        virtualPageViewValue: 'ajaxCartView'
      });
      Simba.gtmPushEvent(eventData);
    });
    return promise;
  }

  function fireGTMCartUpdateCartEvent(optionData) {
    var promise = new Promise((resolve) => {
      Simba.gtmConstructEventData('CartUpdateCart', optionData)
        .then((eventData) => {
          Simba.gtmPushEvent(eventData);
        })
        .then(() => {
          let eventName = 'CartUpdateAddProduct';
          if (optionData.isRemoveButtonPressed) eventName = 'CartRemoveProduct';
          if (optionData.quantityOld > optionData.quantityNew) eventName = 'CartUpdateRemoveProduct';
          Simba.gtmConstructEventData(eventName, optionData).then((eventData2) => {
            Simba.gtmPushEvent(eventData2);
          });
        });

      resolve();
    });

    return promise;
  }

  function fireGTMFullCartChangeEvent() {
    var eventData = Simba.gtmConstructEventData('CartFullCartChange');
    if (eventData) {
      Simba.gtmPushEvent(eventData);
    }
  }

  async function calculateEcoTaxTotal(cart) {
    var ecoTaxTotal = 0;
    await cart.items.forEach(async function (item) {
      var variant = await Simba.ProductAsync.load(item.variant_id);
      ecoTaxTotal += variant?.ecoTaxRaw * item.quantity;
    });

    return ecoTaxTotal;
  }

  function createCartLevelDiscountApplications(cart) {
    var template = '';
    const discounts = [];

    for (const discount of cart.cart_level_discount_applications) {
      // The shape of the object is different for GET cart.js and POST cart.js
      let title;
      let amount;
      if (discount.title) {
        // Must be a GET
        title = discount.title;
        amount = discount.total_allocated_amount;
      } else {
        // Must be a POST
        title = discount.discount_application.title;
        amount = discount.discount_application.total_allocated_amount;
      }

      // Sum all allocations for the same code
      if (discounts[title]) {
        discounts[title] += amount;
      } else {
        discounts[title] = amount;
      }
    }

    for (const discount of Object.keys(discounts)) {
      template +=
        '<div class="flex justify-between mb-20 text-blue-accent">' +
        '  <span>' +
        $('[data-cart-level-discounts-container]').attr('data-cart-level-discount-label') +
        ':</span><span class="uppercase">' +
        discount +
        '</span> <span class="align-right">-' +
        formatWithoutTrailingZeros(discounts[discount]) +
        '</span>' +
        '</div>';
    }

    return template;
  }

  async function getExtraDiscountFromComparePrices(cart) {
    // Caculate extra savings from compare prices
    var extraDiscount = 0;
    await cart.items.forEach(async function (cartItem) {
      var comparePrice;
      var originalPrice;
      var variant = await Simba.ProductAsync.load(cartItem.variant_id);
      if (variant?.compareAtPriceRaw > cartItem.original_price) {
        originalPrice = cartItem.original_line_price;
        comparePrice = variant?.compareAtPriceRaw * cartItem.quantity;

        extraDiscount += comparePrice - originalPrice;
      }
    });

    return extraDiscount;
  }
})();
